import { render } from "./SimplePage.vue?vue&type=template&id=c1c658fe&scoped=true"
import script from "./SimplePage.vue?vue&type=script&lang=js"
export * from "./SimplePage.vue?vue&type=script&lang=js"

import "./SimplePage.vue?vue&type=style&index=0&id=c1c658fe&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1c658fe"]])

export default __exports__